import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Topbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (!window.confirm('¿Seguro que deseas cerrar sesión?')) return;
    // logout() ahora invalida el token en Supabase, así que hay que esperarlo
    // antes de navegar.
    await logout();
    navigate('/login');
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <img
          src="/images/logo_camara.png"
          alt="CCIA"
          className="topbar-logo"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        {/* <div className="topbar-title">Revista CCIA — Panel Admin</div> */}
      </div>
      <div className="topbar-right">
        {user && (
          <div className="user-info">
            Hola, <strong>{user.name}</strong>
          </div>
        )}
        <button className="btn btn-danger btn-sm" onClick={handleLogout}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );
};

export default Topbar;
